import { Divider, Flex } from '@servicetitan/anvil2';
import { Headline, Eyebrow } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { FC } from 'react';

interface CountDisplayProps {
    count: number;
    name: string;
    includeDivider?: boolean;
    footerContent?: JSX.Element;
    mobile?: boolean;
}

export const CountDisplay: FC<CountDisplayProps> = observer(
    ({ count, footerContent, includeDivider, mobile, name }) => {
        return (
            <Flex direction="row" flex={1}>
                {!mobile && includeDivider && <Divider vertical spacing={6} />}
                <Flex direction="column" gap={2} alignContent="flex-start">
                    <Flex direction="row" gap={1} alignItems="flex-end">
                        <Headline className="m-b-0" size="large">
                            {count}
                        </Headline>
                        <Eyebrow size="small">{name}</Eyebrow>
                    </Flex>
                    {footerContent}
                </Flex>
            </Flex>
        );
    }
);
